import { Link } from "react-router-dom";
import { Building2, Check, X } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";
import { COMPANY as C } from "../constants/company";
import { Reveal, SectionTitle } from "./Primitives";

export const PlatformStatus = () => {
  const { t } = useLang();
  const s = t.status;
  return (
    <section id="status" data-testid="status-section" className="bg-canvas py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid gap-12 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <SectionTitle eyebrow={s.eyebrow} title={s.title} sub={s.body} testId="status-title" />
            <Reveal delay={0.2}>
              <div data-testid="status-company-card" className="card-soft mt-8 p-6">
                <p className="eyebrow text-mist">{s.operatedBy}</p>
                <div className="mt-3 flex items-center gap-3">
                  <span className="flex h-11 w-11 items-center justify-center rounded-2xl bg-violet-100 text-violet-700"><Building2 size={20} /></span>
                  <div>
                    <p className="font-display text-xl font-extrabold text-ink">{C.legalName} — {C.country}</p>
                    <p className="text-xs text-mist">NIT {C.nit} · {C.chamber} · {C.city}</p>
                  </div>
                </div>
                <div className="mt-5 flex flex-wrap gap-2">
                  <Link to="/about" data-testid="status-about-link" className="pill btn-primary px-4 py-2 text-xs font-semibold">{s.aboutCta}</Link>
                  <Link to="/legal/terms" data-testid="status-legal-link" className="pill btn-ghost px-4 py-2 text-xs font-semibold">{s.legalCta}</Link>
                </div>
              </div>
            </Reveal>
          </div>
          <div className="grid gap-4 sm:grid-cols-2 lg:col-span-7 lg:mt-6">
            <Reveal>
              <div className="card-soft h-full p-6">
                <p className="eyebrow text-violet-600">{s.canTitle}</p>
                <ul className="mt-4 space-y-3">
                  {s.can.map((c) => (
                    <li key={c} className="flex items-start gap-3 text-sm text-ink">
                      <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-violet-100 text-violet-700"><Check size={12} /></span>
                      {c}
                    </li>
                  ))}
                </ul>
              </div>
            </Reveal>
            <Reveal delay={0.08}>
              <div className="card-soft h-full p-6">
                <p className="eyebrow text-mist">{s.cannotTitle}</p>
                <ul className="mt-4 space-y-3">
                  {s.cannot.map((c) => (
                    <li key={c} className="flex items-start gap-3 text-sm text-ink-2">
                      <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-lilac text-mist"><X size={12} /></span>
                      {c}
                    </li>
                  ))}
                </ul>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};
